<template>
  <div>
    <LoginForm :errors="errorText" @submit="login($event)" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { ROUTES, ROUTES_NAME } from '@/common/constants';
import LoginForm from '@/components/forms/auth/LoginForm';
import { auth } from '@/mixins/auth.mixin';

export default {
  name: ROUTES_NAME.login,
  components: {
    LoginForm
  },

  mixins: [auth],
  computed: {
    ...mapGetters('auth', ['errors']),
    errorText() {
      return this.errors || '';
    }
  },
  mounted() {
    if (this.isAuth) {
      this.$router.push(ROUTES.sessions);
    }
  },
  methods: {
    ...mapActions('auth', ['login'])
  }
};
</script>
